module.exports = __webpack_public_path__ + "static/WEDDING E&M-131-d16e09a5684146863258f578c256c850.jpg";